import { render, staticRenderFns } from "./img_iframe.vue?vue&type=template&id=dcaecbda"
import script from "./img_iframe.vue?vue&type=script&lang=js"
export * from "./img_iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcaecbda')) {
      api.createRecord('dcaecbda', component.options)
    } else {
      api.reload('dcaecbda', component.options)
    }
    module.hot.accept("./img_iframe.vue?vue&type=template&id=dcaecbda", function () {
      api.rerender('dcaecbda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/markManage/img_iframe.vue"
export default component.exports